import { z } from 'zod'

const transportRowSchema = z.object({
	selected: z.boolean().default(false),
	date: z.string().default(''),
	description: z.string().min(1, 'Required'),
	id: z.number(),
	requisitionActId: z.union([z.string(), z.number()]).optional(),
	medicalActId: z.union([z.string(), z.number()]).optional(),
	requisitionId: z.string().min(1, 'Required'),
	time: z.string().default(''),
	transportId: z.string().default(''),
	transportName: z.string().optional(),
})

export const insertTransportSchema = z
	.object({
		requisitionId: z.string().min(1, 'Required'),
		establishment: z.string().min(1, 'Required'),
		useAlternativeAddress: z.boolean().default(false),
		alternativeAddress: z.string().optional(),
		observations: z.string().optional(),
		transportList: z.array(transportRowSchema).min(1, 'Required'),
	})
	.superRefine((data, ctx) => {
		const selectedRows = data.transportList.filter((row) => row.selected)

		if (selectedRows.length === 0) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['transportList'],
				message: "O campo 'lista de transportes' está vazio",
			})
			return
		}

		data.transportList.forEach((row, index) => {
			if (!row.selected) return

			if (!row.date?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['transportList', index, 'date'],
					message: 'Required',
				})
			}

			if (!row.time?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['transportList', index, 'time'],
					message: 'Required',
				})
			}

			if (!row.transportId?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['transportList', index, 'transportId'],
					message: 'Required',
				})
			}
		})
	})
